/* Melder fra om én sidevisning til vår egen server, som teller den.
 *
 * Ingen informasjonskapsler, og ingenting lagres i nettleseren. Det som sendes
 * er hvilken side som vises og hvilket nettsted besøket kom fra. Hvordan det
 * telles står i api/besok.py, og i personvernerklæringen. */

export function meldBesok() {
  if (!navigator.sendBeacon) return;
  navigator.sendBeacon('/besok', new URLSearchParams({ s: location.pathname, r: document.referrer }));
}
